import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-left">
            <div className="footer-menu">
              <h4 className="menu-title">MENU</h4>
              <div className="menu-links">
                <Link to="/shop" onClick={toTop}>
                  Shop New
                </Link>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </div>
            </div>
            <div className="footer-info">
              <h4 className="menu-title">CUSTOMER CARE</h4>
              <div className="menu-links">
                <Link to="/returns" onClick={toTop}>
                  Refunds &amp; Returns
                </Link>
                <Link to="/shipping" onClick={toTop}>
                  Shipping and Delivery
                </Link>
                <Link to="/payments" onClick={toTop}>
                  Payment &amp; Security
                </Link>
                <Link to="/orders-cancellations" onClick={toTop}>
                  Orders &amp; Cancellations
                </Link>
                <Link to="/custom-orders" onClick={toTop}>
                  Custom Orders
                </Link>
                <Link to="/warranty-repairs" onClick={toTop}>
                  Warranty &amp; Repairs
                </Link>
                <Link to="/care-safety" onClick={toTop}>
                  Care &amp; Safety
                </Link>
                <Link to="/product-information" onClick={toTop}>
                  Product Information
                </Link>
                <Link to="/promotions-pricing" onClick={toTop}>
                  Pricing &amp; Promotions
                </Link>
                <Link to="/faqs" onClick={toTop}>
                  FAQs
                </Link>
              </div>
            </div>
            <div className="footer-policy">
              <h4 className="menu-title">LEGAL &amp; POLICIES</h4>
              <div className="menu-links">
                <Link to="/policies" onClick={toTop}>
                  Policy Center
                </Link>
                <Link to="/terms" onClick={toTop}>
                  Terms of Service
                </Link>
                <Link to="/privacy" onClick={toTop}>
                  Privacy Policy
                </Link>
                <Link to="/privacy-choices" onClick={toTop}>
                  Privacy Choices
                </Link>
                <Link to="/cookies" onClick={toTop}>
                  Cookie Policy
                </Link>
                <Link to="/intellectual-property" onClick={toTop}>
                  Intellectual Property
                </Link>
                <Link to="/accessibility" onClick={toTop}>
                  Accessibility
                </Link>
                <Link to="/complaints" onClick={toTop}>
                  Complaints
                </Link>
                <Link to="/disclaimer" onClick={toTop}>
                  Website Disclaimer
                </Link>
              </div>
            </div>
          </div>

          <div className="footer-newsletter">
            <h2>CONNECT</h2>
            <p>
              <a href="mailto:wares@tuddlepetgoods.club">
                wares@tuddlepetgoods.club
              </a>
              <br />
              HANG SHING LAU
              <br />
              QUEEN&apos;S ROAD CENTRAL 219
              <br />
              CENTRAL AND WESTERN DISTRICT
              <br />
              HONG KONG
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-center">
            <span>© Tuddlepetgoods 2026. ALL RIGHTS RESERVED.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
